import React from 'react';
import AccountLockIcon from 'mdi-react/AccountLockIcon';
import { format } from 'date-fns';

import Button from '@xcritical/button';

import { EmptyState } from '@crm-framework/empty-state';
import { oldShortDateTimeFormat } from '@crm-framework/utils';

import { BaseLayout } from '@crm-package/layouts';

import { Page } from './styles';

export const LicenseExpiration: React.FC<{
  expirationDate: string;
  onAgree: () => void;
}> = ({ expirationDate, onAgree }) => (
  <Page>
    <BaseLayout>
      <EmptyState
        icon={AccountLockIcon}
        header={`Your license will be terminated ${format(
          new Date(expirationDate),
          oldShortDateTimeFormat
        )}.`}
        description={
          <>
            <p>Please contact to your administrator.</p>
            <Button appearance="primary" onClick={onAgree}>
              Agree and continue working
            </Button>
          </>
        }
      />
    </BaseLayout>
  </Page>
);
